<template>
    <div>
        <!-- Diálogo genérico (texto simples / aprovar / reprovar) -->
        <v-dialog content-class="br-15" v-model="dialog" width="600">
            <v-card>
                <v-toolbar elevation="0" dark class="primary-degrade white--text fix-flex">
                    <v-toolbar-title>{{ dialogTitulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab width="24px" height="24px" elevation="0" light @click="dialog = false">
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    {{ dialogTexto }}
                    <div v-if="acordo && acordo.filiais && acordo.filiais.length">
                        <h3 class="mt-4 mb-2">Filiais Selecionadas:</h3>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Filial</th>
                                    <th>Cidade</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="filial in acordo.filiais" :key="filial.id">
                                    <td>{{ filial.nome || filial.filial }}</td>
                                    <td>{{ filial.cidade }}</td>
                                    <td>{{ filial.estado }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Diálogo de Renovação (período + clusters, sem check-out) -->
        <v-dialog content-class="br-15" v-model="dialogRenovar" width="600">
            <v-card>
                <v-toolbar elevation="0" dark class="primary white--text fix-flex">
                    <v-toolbar-title>{{ dialogTitulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab width="24px" height="24px" elevation="0" light @click="dialogRenovar = false">
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    Selecione a data final de
                    <strong style="color: var(--v-primary-base)">renovação</strong>
                    do acordo.
                    <br /><br />
                    <v-form v-model="isRenovar">
                        <MesInput
                            v-model="mesFinal"
                            :min="termino"
                            label="Selecionar Período"
                            :rules="regra.renovar"
                            required
                        />
                        <template v-if="lista.modelos_ck.length > 0">
                            <br />
                            <v-select
                                label="Modelo Check-out"
                                outlined
                                dense
                                v-model="modelo_ck"
                                :items="lista.modelos_ck"
                                :rules="regra.modelo"
                                :disabled="lista.modelos_ck.length == 1"
                                required
                            />
                        </template>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button px-6 mb-3 mr-2"
                        @click="renovarAcordo()"
                        :disabled="!isRenovar || carregando"
                    >
                        Renovar Acordo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo de Cancelamento (justificativa + parcial/total) -->
        <v-dialog content-class="br-15" v-model="dialogCancelar" width="600">
            <v-card>
                <v-toolbar elevation="0" dark class="error white--text fix-flex">
                    <v-toolbar-title>{{ dialogTitulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab width="24px" height="24px" elevation="0" light @click="dialogCancelar = false">
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    Deseja realmente <span style="color: red">cancelar</span> o acordo?
                    <br /><br />
                    <v-form v-model="isJustificativa">
                        <v-select
                            label="Justificativa"
                            v-model="justificativa"
                            :items="justificativasCancelamento"
                            :rules="regra.justificativa"
                            outlined
                            dense
                        ></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="new-button mr-3 px-4 mb-2" @click="dialogCancelar = false">
                        <v-icon class="mr-3">mdi-close-circle</v-icon>
                        Fechar
                    </v-btn>
                    <v-btn
                        class="new-button px-4 mb-2"
                        color="primary"
                        @click="cancelarAcordo('atual')"
                        :disabled="!isJustificativa || carregando"
                        v-if="cancelamentoAcordoParcial"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Cancelar acordo
                    </v-btn>
                    <v-btn
                        class="new-button px-4 mb-2"
                        color="primary"
                        @click="cancelarAcordo()"
                        :disabled="!isJustificativa || carregando"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        {{ cancelamentoAcordoParcial ? "Cancelar todo contrato" : "Sim, quero cancelar" }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo de Liberação -->
        <v-dialog content-class="br-15" v-model="dialogLiberar" width="600">
            <v-card>
                <v-toolbar elevation="0" dark class="primary-degrade white--text fix-flex">
                    <v-toolbar-title>{{ dialogTitulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab width="24px" height="24px" elevation="0" light @click="dialogLiberar = false">
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    Deseja realmente
                    <strong style="color: var(--v-primary-base)">liberar</strong>
                    os acordos selecionados, juntos eles somam o total investido de:
                    <strong style="color: var(--v-primary-base)">{{ dialogTexto }}</strong>
                    <br /><br />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="new-button ml-auto mb-2 mr-2 px-3" color="error" @click="dialogLiberar = false">
                        <v-icon class="mr-3">mdi-close-circle</v-icon>
                        Não, não liberar
                    </v-btn>
                    <v-btn class="new-button mb-2 px-3" color="primary" @click="liberarAcordo()">
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Sim, liberar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="alerta" :color="alertaColor" :timeout="alertaTimeout" top style="z-index: 400">
            <v-alert :type="alertaColor">{{ alertaTexto }}</v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">Fechar</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'DialogoCircuito',
    props: {
        acordo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            id_acordo: null,
            acordosALiberar: [],
            dialog: false,
            dialogRenovar: false,
            dialogCancelar: false,
            dialogLiberar: false,
            dialogTitulo: '',
            dialogTexto: '',
            carregando: false,
            // Renovação
            termino: null,
            mesFinal: null,
            clusters_acordo: [],
            modelo_ck: null,
            lista: {
                modelos_ck: [],
            },
            isRenovar: false,
            // Cancelamento
            justificativa: null,
            isJustificativa: false,
            cancelamentoAcordoParcial: false,
            justificativasCancelamento: [],
            // Feedback
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            regra: {
                justificativa: [(v) => !!v || 'Selecione uma justificativa.'],
                renovar: [
                    (v) => !!v || 'Selecione a data final de renovação do acordo.',
                    (v) => (v && v >= this.mesAtual) ||
                        'A data final de renovação do acordo deve ser igual ou posterior ao mês atual',
                ],
                modelo: [(v) => !!v || 'O campo modelo check-out é obrigatório'],
            },
        }
    },
    async created() {
        try {
            const response = await this.$http().post('/acordoCampanhaCircuito/listaCampos', {});
            const lista = response.data || {};
            this.justificativasCancelamento = [
                { text: '', value: '' },
                ...(lista.justificativasCancelamento || []),
            ];
        } catch (e) {
            this.justificativasCancelamento = [{ text: '', value: '' }];
        }
    },
    computed: {
        mesAtual() {
            return this.$moment ? this.$moment().format('YYYY-MM') : '';
        },
    },
    methods: {
        // ---------- RENOVAR ----------
        renovacao(item) {
            // Mesma lógica do PDV
            this.modelo_ck = null;
            this.lista.modelos_ck = [];
            this.clusters_acordo = [];
            this.mesFinal = null;

            // Próximo mês após o término atual do acordo
            var termino = new Date(item.termino + '-15');
            termino.setMonth(termino.getMonth() + 1);
            this.termino =
                termino.getFullYear() + '-' + ('0' + (termino.getMonth() + 1)).slice(-2);

            // Check-out orgânico ainda sem modelo definido: oferece as opções
            if (
                item.organico == 1 &&
                (item.espaco_macro || '').toLowerCase() == 'check-out' &&
                (item.check_out_modelo || '') == ''
            ) {
                let _ckout = (item.check_out || '').replace(/ /g, '');
                this.lista.modelos_ck = _ckout != '' ? _ckout.split(',') : [];
            }

            if (this.lista.modelos_ck.length == 1) this.modelo_ck = this.lista.modelos_ck[0];

            if ((item.check_out_modelo || '') != '') {
                this.modelo_ck = item.check_out_modelo;
                this.lista.modelos_ck = [item.check_out_modelo];
            }

            // Para espaços orgânicos, carrega os clusters do acordo automaticamente
            if (item.organico == 1) this.clusters_acordo = item.clusters_acordo;

            this.id_acordo = item.id_acordo;
            this.mesFinal = null;
            this.dialogTitulo = 'Renovar Acordo (Acordo: ' + item.id_acordo + ')';
            this.dialogRenovar = true;
        },
        async renovarAcordo() {
            this.carregando = true;

            var data = {
                id_acordo: this.id_acordo,
                mesFinal: this.mesFinal,
                termino: this.termino,
                modelo_ck: this.modelo_ck,
                clusters_acordo: this.clusters_acordo,
            };

            try {
                var response = await this.$http().post('/acordoCampanhaCircuito/renovarAcordo', {
                    data: data,
                });

                this.$emit('filtrar');

                if (response.data.sucesso) {
                    this.dialogRenovar = false;
                    this.exibeAlerta('success', response.data.msg || 'Acordo renovado com sucesso!');
                } else {
                    this.exibeAlerta('error', this.montaMsgErro(response.data, 'Não foi possível renovar o acordo.'));
                }
            } catch (e) {
                this.exibeAlerta('error', 'Erro de comunicação com o servidor.');
            }

            this.carregando = false;
        },
        // ---------- CANCELAR ----------
        cancelar(item) {
            this.justificativa = null;
            this.id_acordo = item.id_acordo;
            this.dialogTitulo =
                'Cancelar Acordo (Acordo: ' + item.id_acordo + ') - Mês: ' +
                (this.$moment ? this.$moment(item.mes_acordo).format('MM/YYYY') : item.mes_acordo);
            // Pré-acordo (30) ou Espaço reservado (29) permitem cancelamento parcial
            this.cancelamentoAcordoParcial = item.id_status == 30 || item.id_status == 29;
            this.dialogCancelar = true;
        },
        async cancelarAcordo(cancelarApenasAcordoAtual = false) {
            this.carregando = true;
            const justificativa = this.justificativasCancelamento.find(
                (item) => item.value == this.justificativa
            );

            var data = {
                id_acordo: this.id_acordo,
                id_justificativa: this.justificativa,
                justificativa: justificativa ? justificativa.text : '',
                cancelarApenasAcordoAtual: cancelarApenasAcordoAtual == 'atual' ? true : false,
            };

            try {
                var response = await this.$http().post('/acordoCampanhaCircuito/cancelarAcordo', {
                    data: data,
                });

                this.$emit('filtrar', false);

                if (response.data.sucesso) {
                    this.dialogCancelar = false;
                    this.exibeAlerta('success', response.data.msg || 'Acordo cancelado com sucesso!');
                } else {
                    this.exibeAlerta('error', response.data.msg || 'Não foi possível cancelar o acordo.');
                }
            } catch (e) {
                this.exibeAlerta('error', 'Erro de comunicação com o servidor.');
            }

            this.carregando = false;
        },
        // ---------- LIBERAR ----------
        liberar(acordos, investimento = 0) {
            this.acordosALiberar = acordos;
            this.dialogTitulo = 'Liberar Acordos';
            this.dialogTexto = (investimento || 0).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            });
            this.dialogLiberar = true;
        },
        liberarAcordo() {
            this.$emit('liberarAcordo', this.acordosALiberar);
            this.dialogLiberar = false;
        },
        // ---------- APROVAR / REPROVAR ----------
        aprovar(payload) {
            this.$emit('aprovarAcordo', payload);
        },
        reprovar(payload) {
            this.$emit('reprovarAcordo', payload);
        },
        // ---------- util ----------
        montaMsgErro(resData, fallback) {
            if (resData && resData.msg) return resData.msg;
            if (resData && Array.isArray(resData.erros) && resData.erros.length) {
                return resData.erros.map((e) => (e && e.msg ? e.msg : e)).join(' | ');
            }
            return fallback;
        },
        exibeAlerta(cor, texto) {
            this.alerta = true;
            this.alertaColor = cor;
            this.alertaTimeout = cor === 'success' ? 3000 : -1;
            this.alertaTexto = texto;
        },
    }
}
</script>

<style scoped>
</style>
